import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'cft-holy-grail-grid-col-left',
  templateUrl: './holy-grail-grid-col-left.component.html',
  styles: [
    `
      @reference '../../../../styles/app-reference.css';

      :host {
        @apply hidden sm:block;
        @apply shrink-0 grow-0 basis-[11.25rem];
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolyGrailGridColLeftComponent {}
